export const isSkeletonRow = (rowId: string | number) =>
  rowId.toString().startsWith('skeleton');
